<template>
  <div class="main-content">
    <!-- Section: inner-header -->

    
 <div class="container pt-100">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
    <h2 class="text-theme-colored text-center">Termini e condizioni</h2>
            </div>
          </div>
        </div>
      </div>

    <!-- Section: Terms -->
    <section id="terms">
      <div class="container pt-70">
        <div class="section-content">
          <div id="texte_a_afficher" class="texte_inselectionnable">
            <span class="stabilisation"></span>
            <p class="title text-center letter-space-2 font-24 text-theme-colored">
              <strong>Condizioni Generali di Vendita</strong>
            </p>
            <p class="art-title">
              <strong>
                <br />
                <br />OGGETTO:
              </strong>
            </p>
            <p style="text-align: left;">
              <br />Il proprietario del sito a dominio <span id="span_id_url"><a href="https://www.sarahfitnessmovementflow.com" target="_blank">https://www.sarahfitnessmovementflow.com</a></span> è Abdessalem Sarah, con sede legale in 20063, Cernusco Sul Naviglio (MI), Via Andrea Fermini n. 1, P.I. 04457370163. Le presenti Condizioni Generali regolano i rapporti tra Abdessalem Sarah e gli Utenti che acquistano corsi sportivi e percorsi alimentari ed ogni altro servizio commercializzato da Abdessalem Sarah attraverso il citato sito internet <a href="https://www.sarahfitnessmovementflow.com" target="_blank">https://www.sarahfitnessmovementflow.com</a>; L’obbiettivo di Abdessalem Sarah è quello di fornire strumenti utili per migliorare la propria forma fisica conducendo uno stile di vita sano e sportivo.
Tutte le comunicazioni inerenti all’esecuzione del presente Contratto dovranno avvenire in forma scritta al seguente indirizzo mail sarah.abdessalem@pec.it.
Le presente Condizioni di vendita si intendono lette, comprese ed integralmente accettate al momento della conferma d’acquisto dei prodotti commercializzati da Abdessalem Sarah.
Qualsiasi comportamento, anche ripetuto di una delle Parti non corrispondente ad una delle presenti Condizioni non potrà in alcun modo pregiudicare il diritto dell’altra Parte di chiedere, in qualsiasi momento, l’applicazione delle stesse.
             </p>

            <p class="art-title">
              <strong>
                <br />
                <br />DECLINAZIONE DELLE RESPONSABILITÀ
              </strong>
            </p>
            <p>
              La finalità dei servizi offerti è quella di aiutare gli Utenti che lo desiderano a migliorare il proprio stile di vita. Tuttavia posto che l’attività fisica può comportare dei rischi, è responsabilità esclusiva dell’utente accertare con il proprio medico curante e/o di fiducia l’idoneità allo svolgimento degli allenamenti. Qualora gli allenamenti siano seguiti da donne incinta, sarà responsabilità dell’Utente accertarsi con il proprio medico/ginecologo circa l’idoneità dei programmi di allenamento. Abdessalem Sarah non divulga servizi medici o servizi professionali sulla salute né assume alcuna garanzia in merito ai risultati ed ad eventuali conseguenze dell’utilizzo dei servizi offerti.
I servizi possono non essere idonei per alcune tipologie di persone, in particolare in presenza di alcune patologie, allergie o intolleranze alimentari. L’Utente è sempre tenuto a consultare il proprio medico di fiducia.
Inoltre, attraverso l’aquisto dei servizi, l’Utente dichiara di godere di perfetta salute.
Abdessalem Sarah non sarà responsabile di infortuni scaturiti nell’esecuzione dei programmi di allenamento e l’Utente, acquistando i servizi assume tale rischio.
 </p>
            <p class="art-title">
              <strong>
                <br />
                <br />CARATTERISTICHE DEL SERVIZIO
              </strong>
            </p>
            <p>
              <br />Il servizio è composto dalla vendita di programmi di allenamento personalizzati anche combinati con programmi nutrizionali, lezioni singole e consulenze private.
I servizi proposti da Abdessalem Sarah sono i seguenti:     </p>
<p>- programma di allenamento personalizzato mensile</p>
<p>- Programma di allenamento personalizzato trimestrale</p>
<p>- Programma di allenamento personalizzato + nutrion trimestrale</p>
<p>- Programa personalizzato semestrale</p>
<p>- Programma di allenamento personalizzato annuale</p>
<p>- Pacchetto 5 lezioni da 45 minuti</p>
<p>- Pacchetto 10 lezioni da 45 minuti + 1 in omaggio</p>
<p>- Consulenza privata 30 minuti</p>
<p>- Consulenza privata 60 minuti</p>
Per quanto attiene alla sfera nutrizionale, il servizio è operato dalla nutrizionista Dott.ssa Giulia Sulsenti (email: movementflownutrition@gmail.com).
       <p class="art-title">
              <strong>
                <br />
                <br />TERMINI E MODALITÀ DI PAGAMENTO
              </strong>
            </p>
            <p>
              <br />L’utente ha l’obbligo di confermare l’ordine dei prodotti selezionati e, conseguentemente, effettuare il pagamento richiesto. Una volta effettuato il pagamento ed avvenuto l’effettivo accredito il contratto di compravendita potrà considerarsi concluso.
L’Utente manleva sin da ora Abdessalem Sarah da qualsiasi responsabilità derivante dall’inserimento all’interno del form per effettuare l’ordine di dati contabili/fiscali errati o falsi. In caso di sanzioni a carico di Abdessalem Sarah quest’ultima potrà rivalersi sull’Utente che ha inserito i dati errati o falsi.
Abdessalem Sarah ha l’insindacabile facoltà di non accettare l’ordine ricevuto. Nel caso in cui Abdessalem Sarah abbia già ricevuto il pagamento dell’ordine che intende non accettare, provvederà all’emissione della relativa nota di credito ed al rimborso dell’importo già pagato dell’utente.
            </p>
            <p class="art-title">
              <strong>
                <br />
                <br />PREZZI
              </strong>
            </p>
            <p>
              <br />I prezzi sono pubblicati su <a href="https://www.sarahfitnessmovementflow.com" target="_blank">https://www.sarahfitnessmovementflow.com</a>, i pagamenti e le fatture degli ordini sono in Euro.
I prezzi dei prodotti sono da intendersi comprensivi unicamente di IVA. I prezzi sono calcolati in funzione dell’ordine dell’Utente e gli sono cominciati prima della conferma dello stesso.
            </p>
            <p class="art-title">
              <strong>
                <br />
                <br />CONSEGNA DEI SERVIZI ACQUISTATI
              </strong>
            </p>
            <p>
             Abdessalem Sarah si impegna a fornire il programma di allenamento con scheda personalizzata entro 7/10 giorni dalla ricezione dell’ordine.
Abdessalem Sarah si impegna a mettersi in contatto con l’Utente che ha acquistato una consulenza privata nonché ad effettuare la consulenza stessa entro 7 giorni dalla ricezione dell’ordine. Eventuali ritardi dovuti da caso fortuito, forza maggiore ovvero sopravvenienza di fatti o nuove circostanze imprevedibili non saranno imputabili a Abdessalem Sarah. 
             </p>
            <p class="art-title">
              <strong>
                <br />
                <br />CODICI PROMOZIONE
              </strong>
            </p>
            <p>
              <br />I codici promozione sono voucher a valore, personalizzati, per mezzo dei quali al Cliente è consentito di usufruire di sconti per i prodotti su <a href="https://www.sarahfitnessmovementflow.com" target="_blank">https://www.sarahfitnessmovementflow.com</a>. La casella inerente questo servizio appare sulla prima pagina del processo di acquisto: una volta inseriti gli articoli nel carrello, il Cliente procede con il Processo di acquisto e compare una schermata in cui inserire i dati di spedizione ed a lato lo spazio per inserire il Codice Promozione.
Viale Roma pone alcune limitazioni all’utilizzo del codice promozione:
               </p>
<p>✓ è utilizzabile una sola volta</p>
<p>✓ non può essere convertito in denaro</p>
<p>✓ non è possibile utilizzarne più di uno per uno stesso ordine</p>
<p>✓ ha una data di inizio e di fine validità che non può essere oltrepassata</p>
<p>✓ Il Codice Promozione può essere utilizzato insieme a buoni e voucher rilasciati nel caso di</p>
crediti aperti
            <p class="art-title">
              <strong>
                <br />
                <br />FORME DI PAGAMENTO
              </strong>
            </p>
            <p>
              <br />Abdessalem Sarah accetta i seguenti metodi di pagamento:</p>
                  <p>- Visa, Maestro, MasterCard e American Express (AMEX)</p>
                  <p>- Pagamento PayPal: il Cliente che decida di avvalersi del metodo di pagamento PayPal, può</p>
                  pagare direttamente tramite il suo conto PayPal.
            
            <p class="art-title">
              <strong>
                <br />
                <br />DIRITTO DI RECESSO
              </strong>
            </p>
            <p>
              <br />Qualora il Cliente non fosse soddisfatto del proprio acquisto, può esercitare il diritto di recesso entro 14 giorni a partire dall’attivazione del servizio ai sensi dell’art. 64 Codice del Consumo, senza fornire alcuna spiegazione o pagare penalità. Quando il tempo massimo per esercitare questo diritto scade un giorno festivo, tale termine è prolungato fino al primo giorno lavorativo utile. L’esercizio del diritto di recesso dovrà essere comunicato tramite raccomanda A/R all’indirizzo 20063, Cernusco Sul Naviglio (MI), Via Andrea Fermini n. 1 ovvero all’indirizzo pec sarah.abdessalem@pec.it. Il Cliente verrà rimborsato mediante il metodo di pagamento utilizzato.
            </p>
            <p class="art-title">
              <strong>
                <br />
                <br />SITO INTERNET
              </strong>
            </p>
            <p>
              <br />Abdessalem Sarah pubblica i servizi e le relative informazioni sul personale sito web https:// www.sarahfitnessmovementflow.com per fornire un servizio agli utenti, ma declina ogni responsabilità sulla possibile presenza di eventuali inesattezze tecniche e/o errori tipografici. Il Cliente è invitato gentilmente, qualora si imbattesse in un errore, a comunicarlo (mail: sarah.abdessalem@pec.it). Sarà disposta una correzione immediata.
Abdessalem Sarah non offre garanzia che le informazioni pubblicate sul personale sito siano in conformità con le leggi della giurisdizione del Paese di residenza del Cliente e si riserva inoltre la
     
facoltà, qualora lo ritenga opportuno, di apportare correzioni e cambiamenti al sito senza doverne fornire alcun preavviso. In ogni caso vi è la conformità alla normativa Europea, sia per quanto riguarda la tutela del consumatore, sia per quanto concerne il trattamento dei dati personali.
Vi è assoluto divieto di comunicare dati falsi necessari per completare l’ordine online. In tale denegato caso l’Utente dovrà risarcire l’eventuale danno, derivante dall’inserimento di dati falsi, subito da Abdessalem Sarah o che venga richiesto a Abdessalem Sarah da soggetti terzi.
L’Utente manleva sin da ora Abdessalem Sarah da qualsiasi responsabilità derivante dall’inserimento all’interno del form per effettuare l’ordine di dati contabili/fiscali errati o falsi. In caso di sanzioni a carico di Abdessalem Sarah quest’ultima potrà rivalersi sull’Utente che ha inserito i dati errati o falsi.
Si garantisce che il sito Abdessalem Sarah è protetto secondo gli standard Internet internazionali. Il Cliente può essere rassicurato di non incontrare virus. Tuttavia, è declinata ogni responsabilità circa eventuali virus (o altri problemi) nei quali il Cliente può incorrere durante l'uso improprio del sito web e declina altresì ogni responsabilità da eventuali anomalie di funzionamento del sito web per la disattivazione dei "cookies" nel browser del Cliente.
            </p>
            
            <p class="art-title">
              <strong>
                <br />
                <br />TERMINI LEGALI
              </strong>
            </p>
            <p>
              <br />Il Cliente che acceda al sito Abdessalem Sarah, si impegna ad accettare le condizioni presenti nella seguente dichiarazione e a rispettarle.
Il sito ed i relativi servizi sono esclusivamente ad uso personale (del Consumatore Finale).
Le pagine che il Cliente visualizza rispondono a scopi di informazione sui servizi proposti con la connessa possibilità di acquisto degli stessi.
Il presente contratto verrà interpretato esclusivamente in base alla legge italiana.
Qualunque controversia nascente dall’interpretazione e/o esecuzione e/o risoluzione del presente contratto verrà devoluta alla competenza esclusiva del Tribunale o del Giudice di Pace di Bergamo.
            </p>
            <p class="art-title">
              <strong>
                <br />
                <br />MODIFICHE E INTERPRETAZIONE DEL CONTRATTO
              </strong>
            </p>
            <p>
              <br />Eventuali modifiche o postille alle Condizioni contrattuali avranno efficacia solo ed esclusivamente se approvate per iscritto dalle Parti.
L’eventuale invalidità o inefficacia di una o più clausole contrattuali non inficerà in nessun caso la validità o l’inefficacia delle altre clausole contrattuali.
            </p>

             <p class="art-title">
              <strong>
                <br />
                <br />PROPRIETÀ
              </strong>
            </p>
            <p>
              <br />I documenti, le immagini, i caratteri, il layout, il software, i codici e i format scripts sono di proprietà esclusiva di Abdessalem Sarah.
Non è ammessa qualsiasi riproduzione, ridistribuzione a terzi e alterazione del suddetto materiale salvo previa autorizzazione.
            </p>


             <p class="art-title">
              <strong>
                <br />
                <br />DOMICILIAZIONE DELLE PARTI E COMUNICAZIONI
              </strong>
            </p>
            <p>
              <br />Ai fini dell’esecuzione del presente contratto le parti saranno domiciliate presso le rispettive sedi legali.
Tutte le comunicazioni inerenti all’esecuzione del contratto verranno effettuate ed inoltrate a mezzo e-mail, salvo per le comunicazioni per cui la legge preveda forme di notificazione particolari.
            </p>

             <p class="art-title">
              <strong>
                <br />
                <br />PROTEZIONE DEI DATI PERSONALI
              </strong>
            </p>
            <p>
              <br />L’Utente conferma di avere letto ed accettato l’informativa ai sensi del Regolamento (UE) 679/2016 e del D. Lgs. 196/2003 e successive modifiche.
Le Parti garantiscono reciprocamente che i dati forniti per effetto del presente Contratto saranno trattati nel rispetto dei principi di legalità, minimizzazione e adeguatezza.
La Parti dichiarano di essere consapevoli che comunicazione dei dati personali dell’utente è indispensabile ai fini della corretta esecuzione del presente Contratto e che Abdessalem Sarah potrà comunicarli a Responsabili Esterni fornitori di servizi.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<style scoped>
.art-title{
  text-align: center;
  font-size: 18px;
}
</style>

<script>
export default {
  name: "TermsAndConditions"
};
</script>